import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { TranslateFieldValueComponent } from 'app/shared/components/translate-field-value/translate-field-value.component';
import { HelperService } from 'app/shared/services/helper.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-textarea-form-field',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, CommonModule, TranslateFieldValueComponent, InputHelperTextComponent],
  templateUrl: './textarea-form-field.component.html',
  styleUrl: './textarea-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaFormFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TextareaFormFieldComponent),
      multi: true,
    }
  ],
})
export class TextareaFormFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() placeholder: string = 'placeholders.type_text_here';
  @Input() isRequired: boolean = false;
  @Input() infoText: string = '';
  @Input() viewMode!: boolean;
  @Input() textareaRows: number = 3;
  @Input() isLabelTopPosition: boolean = false;
  @Input() translatable: boolean = true;
  @Input() helpText!: string;

  translated: string = '';
  formControl: FormControl = new FormControl<string>('');
  errorText: string = '';
  inlineEditMode!: boolean;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private helperService: HelperService
  ) { }

  onTouch: () => void = () => { };
  onChange: (value: any) => void = () => { };

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: string): void {
    this.formControl.setValue(value, { emitEvent: false });

    this.changeDetectorRef.markForCheck();
  }

  translate(event: string) {
    this.translated = event;
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((value) => {
        this.onChange(value);
      });
  }

  validate(control: FormControl) {
    setTimeout(() => {
      this.errorText = this.helperService.handleFieldsErrors(control);
      this.changeDetectorRef.markForCheck();
    });
    return null;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}


